import { computed } from 'vue'
import { useDesignStore } from '@/stores/modules/design'

export function useDesignSetting() {
  const designStore = useDesignStore()

  const getDarkMode = computed(() => designStore.darkMode)

  const getAppTheme = computed(() => designStore.appTheme)

  const getAppThemeList = computed(() => designStore.appThemeList)

  return {
    getDarkMode,
    getAppTheme,
    getAppThemeList
  }
}
